import FormWrapper from '@components/search/forms/FormWrapper'
import TruckForm from '@components/search/forms/TruckForm'
import { frontpageLinks } from '@components/search/formLinks'

const TruckSearchpageForm = ({ query }) => {
    return (
        <FormWrapper
            Form={TruckForm}
            formLinks={frontpageLinks}
            overrideDefaultValues={query}
            active={0}
            linksOnTop
        />
    )
}

export default TruckSearchpageForm